import { graphql } from '@/gql'

export const DEPARTMENTS_WITH_USERS = graphql(`
  query departments(
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $orderBy: [DepartmentsOrderBy!]
    $filter: DepartmentFilter
  ) {
    departments(
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      filter: $filter
      condition: { active: true }
    ) {
      edges {
        node {
          ...Department
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const COMPANY_DEPARTMENTS = graphql(`
  query companyDepartments {
    departments(filter: { active: { equalTo: true } }) {
      nodes {
        alias
        name
        id
      }
    }
  }
`)

export const DEPARTMENTS_QUERY = graphql(`
  query graphileDepartments(
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $orderBy: [DepartmentsOrderBy!]
    $filter: DepartmentFilter
    $includeFieldEntries: Boolean! = false
  ) {
    departments(
      first: $first
      last: $last
      before: $before
      after: $after
      orderBy: $orderBy
      condition: { active: true }
      filter: $filter
    ) {
      edges {
        node {
          ...DepartmentBasicWithFieldEntries
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const DEPARTMENTS_FORM_FIELD_SORT_QUERY = graphql(`
  query getDepartmentsFormFieldSort(
    $first: Int
    $last: Int
    $before: Cursor
    $after: Cursor
    $filter: DepartmentFilter
    $includeFieldEntries: Boolean! = false
    $argFormFieldId: UUID
    $argOrderDirection: String
  ) {
    departmentsSortByFormField(
      first: $first
      last: $last
      after: $after
      before: $before
      filter: $filter
      condition: { active: true }
      argFormFieldId: $argFormFieldId
      argOrderDirection: $argOrderDirection
    ) {
      edges {
        node {
          ...DepartmentBasicWithFieldEntries
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const DEPARTMENTS_INPUT_FIELD_QUERY = graphql(`
  query departmentsInputField(
    $selected: [UUID!]
    $after: Cursor
    $filter: DepartmentFilter
  ) {
    allDepartments: departments(
      first: 20
      condition: { active: true }
      orderBy: NAME_ASC
      after: $after
      filter: $filter
    ) {
      edges {
        node {
          ...DepartmentBasic
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }

    selectedDepartments: departments(
      first: 2000000
      condition: { active: true }
      orderBy: NAME_ASC
      filter: { id: { in: $selected } }
    ) {
      edges {
        node {
          ...DepartmentBasic
        }
      }
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      totalCount
    }
  }
`)

export const DEPARTMENT_QUERY = graphql(`
  query department($id: UUID!) {
    departmentById(id: $id) {
      ...Department
    }
  }
`)

export const DEPARTMENT_BASIC_QUERY = graphql(`
  query departmentBasic($id: UUID!) {
    departmentById(id: $id) {
      ...DepartmentBasic
    }
  }
`)

export const DEPARTMENTS_BASIC_QUERY = graphql(`
  query departmentsBasic(
    $first: Int
    $after: Cursor
    $filter: DepartmentFilter
  ) {
    departments(
      orderBy: NAME_ASC
      condition: { active: true }
      first: $first
      after: $after
      filter: $filter
    ) {
      edges {
        node {
          id
          name
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`)

export const MAIN_DEPARTMENT_QUERY = graphql(`
  query mainDepartment($companyId: UUID) {
    departments(
      filter: {
        companyId: { equalTo: $companyId }
        mainDepartment: { equalTo: true }
      }
    ) {
      edges {
        node {
          ...DepartmentBasic
        }
      }
      totalCount
    }
  }
`)

export const DEPARTMENT_DESCENDANTS = graphql(`
  query departmentDescendants($departmentId: UUID) {
    getDepartmentDescendants(departmentId: $departmentId) {
      edges {
        node {
          id
          name
        }
      }
      totalCount
    }
  }
`)

export const DEPARTMENT_WITH_CHILDREN_QUERY = graphql(`
  query departmentWithChildren($id: UUID!) {
    departmentById(id: $id) {
      ...DepartmentBasic
      departmentsByParentDepartmentId(condition: { active: true }) {
        nodes {
          ...DepartmentBasic
        }
      }
    }
  }
`)

export const EXPORT_DEPARTMENTS_TO_EXCEL = graphql(`
  query exportDepartmentsToExcel(
    $departmentIds: [UUID!]!
    $fields: [String!]!
  ) {
    exportDepartmentsToExcel(
      input: { departmentIds: $departmentIds, fields: $fields }
    ) {
      base64
    }
  }
`)

export const GET_ORGANIZATION_DIAGRAM = graphql(`
  query organizationDiagram {
    organizationDiagram {
      nodes
    }
  }
`)

export const DEPARTMENT_TIME_REGISTRATION_RULE_BREACHES_SUMMARY = graphql(`
  query departmentTimeRegistrationRuleBreachesSummary(
    $departmentId: UUID!
    $fromDate: Datetime!
  ) {
    departmentById(id: $departmentId) {
      id
      ruleBreachesSummary(fromDate: $fromDate) {
        nodes {
          fullName
          jobTitle
          logo
          rule
          date
        }
      }
    }
  }
`)
